import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { createResource } from '@atlassian/react-resource-router';
import type { OgConsolidationUserState } from './common/types.tsx';
import { getOgConsolidationUserState } from './services/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { OG_CONSOLIDATION_USER_STATE_STORAGE_KEY } from './common/constants';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { OgConsolidationUserState } from './common/types';

const RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';

export const consolidationUserStateResource = createResource<OgConsolidationUserState>({
	type: RESOURCE_KEY,
	getKey: () => RESOURCE_KEY,
	getData: (_, { tenantContext: { atlassianAccountId: accountId } }) =>
		getOgConsolidationUserState(accountId).catch((error) => {
			fireErrorAnalytics({
				meta: {
					id: 'consolidationUserStateResource',
					packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
					teamName: 'alexstrasza',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		}),
	maxAge: Infinity,
});
